async function parseJsonSafe(response) {
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
}

function createApiError(response, payload) {
  const message =
    (payload && typeof payload.error === "string" && payload.error) ||
    `Request failed (${response.status})`;
  const error = new Error(message);
  error.status = response.status;
  error.payload = payload;
  return error;
}

function buildQueryString(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const v = String(value).trim();
    if (!v) return;
    search.set(key, v);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

async function requestJson(path, options = {}) {
  const init = {
    credentials: "include",
    ...options,
  };

  if (
    init.body &&
    typeof init.body === "object" &&
    !(init.body instanceof FormData) &&
    !(init.body instanceof URLSearchParams)
  ) {
    init.headers = {
      "Content-Type": "application/json",
      ...(init.headers || {}),
    };
    init.body = JSON.stringify(init.body);
  }

  const response = await fetch(path, init);
  const payload = await parseJsonSafe(response);

  if (!response.ok) {
    throw createApiError(response, payload);
  }

  return payload;
}

export async function listAccessRequests({ areaId, status, limit = 50 }) {
  return requestJson(
    `/api/admin/requests${buildQueryString({
      area_id: areaId,
      status,
      limit,
    })}`
  );
}

export async function updateAccessRequest(id, { areaId, status, notes }) {
  return requestJson(`/api/admin/requests/${encodeURIComponent(String(id))}`, {
    method: "PATCH",
    body: {
      area_id: areaId,
      status,
      notes,
    },
  });
}

export async function createInvite({ email, areaId, role, enabledElections, modules, expiresInDays }) {
  return requestJson("/api/admin/invites", {
    method: "POST",
    body: {
      email,
      area_id: areaId,
      role,
      enabled_elections: Array.isArray(enabledElections) ? enabledElections : [],
      modules: modules && typeof modules === "object" ? modules : {},
      expires_in_days: expiresInDays,
    },
  });
}

export async function listElectionsCatalog({ areaId }) {
  return requestJson(
    `/api/elections${buildQueryString({
      area_id: areaId,
    })}`
  );
}

export async function listAdminUsers() {
  return requestJson("/api/admin/users");
}

export async function getAdminUserDetail(userId) {
  return requestJson(`/api/admin/users/${encodeURIComponent(String(userId))}`);
}

export async function updateAdminUserMembership(userId, membershipId, payload) {
  return requestJson(
    `/api/admin/users/${encodeURIComponent(String(userId))}/memberships/${encodeURIComponent(
      String(membershipId)
    )}`,
    {
      method: "PATCH",
      body: payload,
    }
  );
}

export async function createAdminUserMembership(userId, payload) {
  return requestJson(`/api/admin/users/${encodeURIComponent(String(userId))}/memberships`, {
    method: "POST",
    body: payload,
  });
}

export async function updateAdminUser(userId, payload) {
  return requestJson(`/api/admin/users/${encodeURIComponent(String(userId))}`, {
    method: "PATCH",
    body: payload,
  });
}

export async function deleteAdminUser(userId) {
  return requestJson(`/api/admin/users/${encodeURIComponent(String(userId))}`, {
    method: "DELETE",
  });
}
